import Vue from 'vue'
import moment from 'moment';
import './plugins/axios'
import router  from './router' 
import App from './App.vue'
import store from './store'
import Vuex from 'vuex'
import msgbox from './complementos/msgbox'
import VueCookies from "vue-cookies"; 
import vuetify from '@/plugins/vuetify' 

import VueHtml2pdf from 'vue-html2pdf'
 

Vue.use(VueHtml2pdf)
Vue.prototype.$msgbox = msgbox
Vue.prototype.$info={} 

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
Vue.filter('formatDate', function(value) {
  if (value) {
      return moment(String(value)).format('DD/MM/YYYY')
  }
});
Vue.use(VueCookies) 
Vue.use(Vuex)

new Vue({
  el: '#app',
   store,
   router ,
   vuetify,
  render: h => h(App)
})
